import React from 'react';
import { Phone, Mail, MapPin, Heart, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="heading-3 mb-2" style={{ color: 'var(--medical-red)' }}>Medic on the Move</h3>
            <p className="body-medium mt-4">
              Professional mobile medical homecare services delivered with compassion and expertise.
            </p>
            <p className="body-small mt-4">
              Dr Ismail M. Meer<br />
              MBBS, HPCSA Registered<br />
              Practice No: 1182064
            </p>
          </div>

          <div className="footer-section">
            <h3 className="heading-3 mb-4">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="#about">About Dr Meer</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#packages">Packages</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#booking">Book Appointment</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="heading-3 mb-4">Services</h3>
            <ul className="footer-links">
              <li>Home Visits</li>
              <li>Virtual Consultations</li>
              <li>Medical Examinations</li>
              <li>Chronic Disease Management</li>
              <li>Emergency Care</li>
              <li>Prescriptions & Follow-Ups</li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="heading-3 mb-4">Contact</h3>
            <ul className="footer-contact">
              <li>
                <Phone size={16} />
                <MessageCircle size={16} />
                <a href="https://wa.me/27674933211" target="_blank" rel="noopener noreferrer">067 493 3211</a>
              </li>
              <li>
                <Mail size={16} />
                <a href="mailto:info@mediconthemove.co.za">info@mediconthemove.co.za</a>
              </li>
              <li>
                <MapPin size={16} />
                <span>Durban & Surrounding Areas</span>
              </li>
            </ul>
            <p className="body-small mt-4" style={{ color: 'var(--medical-red)' }}>
              <strong>Hours:</strong> Mon-Sun, 9am-6pm
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">
            © {currentYear} Medic on the Move. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <p className="body-small flex items-center gap-2">
              Made with <Heart size={14} fill="currentColor" className="text-medical-red" /> for quality healthcare
            </p>
            <span className="body-small text-text-muted">|</span>
            <a 
              href="/admin" 
              className="body-small font-medium text-medical-red hover:underline transition"
            >
              Admin Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
